var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomPresetSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.25a.75.75 0 01.75-.75h7.5c.017 0 .034 0 .051.002a3 3 0 015.917-.002h7.324a.75.75 0 010 1.5H14.09a3.001 3.001 0 01-5.665-.02.753.753 0 01-.174.02H.75A.75.75 0 010 3.25zM.947 18.5a.75.75 0 000 1.5h2.484a3.001 3.001 0 005.658 0h12.358a.75.75 0 000-1.5H9.218a3 3 0 00-5.917 0H.947zM.26 10.75a.75.75 0 01.75-.75h12.42a3.001 3.001 0 015.66 0h2.42a.75.75 0 010 1.5h-2.292a3 3 0 01-5.917 0H1.01a.75.75 0 01-.75-.75z",
    fill: "currentColor"
  })));
}
export default SvgCustomPresetSolid;